

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";
// customerRegister
// CUSTOMERREGISTER
const GETEMPLOYEEDASHBOARD= createAsyncThunk(
  "getEmployeeDashboard/getEmployeeDashboard",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const getEmployeeDashboardSlice = createSlice({
  name: "getEmployeeDashboardSlice",
  initialState: {
    getEmployeeDashboard: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfgetEmployeeDashboard: (state) => {
        state.getEmployeeDashboard.loading = false
        state.getEmployeeDashboard.error = false
        state.getEmployeeDashboard.data = []
        state.getEmployeeDashboard.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(GETEMPLOYEEDASHBOARD.fulfilled, (state, action) => {
      state.getEmployeeDashboard = {
        ...state.getEmployeeDashboard,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETEMPLOYEEDASHBOARD.pending, (state, action) => {
      state.getEmployeeDashboard = {
        ...state.getEmployeeDashboard,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETEMPLOYEEDASHBOARD.rejected, (state, action) => {
      state.getEmployeeDashboard = {
        ...state.getEmployeeDashboard,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const getEmployeeDashboardAction = {
    GETEMPLOYEEDASHBOARD,
};

export { getEmployeeDashboardAction };
export default getEmployeeDashboardSlice.reducer;
export const {setInitialStateOfgetEmployeeDashboard} = getEmployeeDashboardSlice.actions
